import React from 'react';

import {FooterModuleLink} from "./footer-module.link";
import {FooterModuleLinkModel} from "../models/footer-module.link-model";

export const FooterModuleLinks = ({controller, links, onItemClick}) => {
  return (
    links.map((link: FooterModuleLinkModel, index) => <FooterModuleLink
      link={link}
      key={link.itemType || index}
      controller={controller}
      onItemClick={(link) => onItemClick && onItemClick(link)}
    />)
  );
}
